import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetEmployeeEmergencyDetails() {
  const { id } = useParams();

  return useQuery(['employee-emergency-details'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_EMERGENCY_CONTACT_API, {
        employee_id: id,
      })
    );
    return res.data;
  });
}
